/* eslint-disable lingui/text-restrictions */
/* eslint-disable lingui/no-unlocalized-strings */

import "./resume-animation.css";

export const ResumeAnimation = () => {
  return (
    <div className="animation-wrapper">
      <div className="FoldImageAnimated_card__3Nznq">
        <div className="FoldImageAnimated_content__5n8A2">
          <div className="FoldImageAnimated_front__2BSzH">
            <div className="relative">
              <img
                alt="Resume Example"
                src="/assets/images/resume1.webp"
                width="430"
                height="608"
                decoding="async"
                data-nimg="1"
                className="FoldImageAnimated_resumeOne__D0ARv"
                style={{ color: "transparent", maxWidth: "100%", height: "auto", zIndex: 1 }}
              />
              <img
                alt="Resume Example 3"
                src="/assets/images/resume3.webp"
                width="507"
                height="563"
                decoding="async"
                data-nimg="1"
                className="FoldImageAnimated_resumeThree__l_nL0"
                loading="lazy"
                style={{ color: "transparent", maxWidth: "100%", height: "auto", zIndex: 1 }}
              />
            </div>
          </div>
          <div className="FoldImageAnimated_back__STkbo">
            <div className="FoldImageAnimated_resumeTwoContainer__VRALz">
              <img
                alt="Resume Example 2"
                src="/assets/images/resume2.webp"
                width="366"
                height="518"
                decoding="async"
                data-nimg="1"
                className="FoldImageAnimated_resumeTwo__Yu6L5"
                style={{ color: "transparent" }}
              />
              <div className="FoldImageAnimated_fontsTwo__aTPxa animation-slide-fade-in-left">
                <img
                  alt="Resume Fonts"
                  src="/assets/images/fonts.webp"
                  width="229"
                  height="451"
                  decoding="async"
                  data-nimg="1"
                  loading="lazy"
                  style={{ color: "transparent", width: "100%", height: "auto" }}
                />
              </div>
              <div className="FoldImageAnimated_newEntryTwo__7OuQ1 animation-slide-fade-in-right">
                <img
                  alt="Resume Text Decoration"
                  src="/assets/images/new-entry.webp"
                  width="287"
                  height="143"
                  decoding="async"
                  data-nimg="1"
                  loading="lazy"
                  style={{ color: "transparent", width: "100%", height: "auto" }}
                />
              </div>
              <div className="FoldImageAnimated_profileTwo__Cab1h">
                <img
                  alt="Real Resume Example"
                  src="/assets/images/profile2.webp"
                  width="228"
                  height="228"
                  decoding="async"
                  data-nimg="1"
                  loading="lazy"
                  style={{ color: "transparent", width: "100%", height: "auto" }}
                />
              </div>
              <div className="FoldImageAnimated_hiredTwo__wGro5">HIRED</div>
            </div>
            <div className="FoldImageAnimated_resumeFourContainer__6itQd">
              <div className="FoldImageAnimated_resumeFour__Lx5d_">
                <img
                  alt="Resume Example 4"
                  src="/assets/images/resume4.webp"
                  width="594"
                  height="612"
                  decoding="async"
                  data-nimg="1"
                  loading="lazy"
                  style={{ color: "transparent", maxWidth: "100%", height: "auto", zIndex: 1 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
